import { render, staticRenderFns } from "./main.vue?vue&type=template&id=f07e8e68"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f07e8e68')) {
      api.createRecord('f07e8e68', component.options)
    } else {
      api.reload('f07e8e68', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=f07e8e68", function () {
      api.rerender('f07e8e68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/components/setting-design/main.vue"
export default component.exports